import React from 'react'
import { Link } from "react-router-dom";

const SinglePostThree = (props) => {
  const {
    blogClass,
    blogImage,
    blogTitle,
    contentClass,
    blogDesc,
    btnClass,
    Id,
    blogAuthor,
    blogPublishedDate,
    blogButtonText,
  } = props;
  return (
    <div
      className={blogClass ? blogClass : "blog-item mb-44"}
      style={{ direction: "rtl" }}
    >
      <div className="image-part">
        <Link to={"/news/" + Id}>
          <img src={blogImage} alt={blogTitle} />
        </Link>
      </div>
      <div className={contentClass ? contentClass : "blog-content"}>
        <ul className="blog-meta">
          <li className="admin">
            <i className="fa fa-user-o"></i> {blogAuthor ? blogAuthor : "admin"}
          </li>
          <li className="date">
            <i className="fa fa-calendar-check-o"></i>{" "}
            {blogPublishedDate ? blogPublishedDate : "June 15, 2019"}
          </li>
        </ul>
        <h3 className="title">
          <a  target='_blank'  href={`https://events.zu.edu.ly/post/${Id}`}  rel="noreferrer" >{blogTitle}</a>
         
       
        </h3>
        <div
          className="desc text-justify"
          dangerouslySetInnerHTML={{ __html: blogDesc.substr(0, 320) }}
        ></div>
        <ul className="blog-bottom rtl">
          <li className="btn-part">
            
            <a  target='_blank'  href={`https://events.zu.edu.ly/post/${Id}`}  rel="noreferrer" >اقرأ المزيد ...</a>


          </li>
        </ul>
      </div>
    </div>
  );
};

export default SinglePostThree;
